import {
    Action,
    DataContainer,
    Feature,
    MiniAction,
    submitMerge,
    submitMiniAction,
    submitMove,
    trackOnNextPageImpression
} from '@otto-ec/tracking-bct';
import {TrackingFeatureStatus} from './types';

export class TrackingService {

    sendTopBrandPromoInitialLoadedTrackingEvent(featureOrder: number, brandImageId: string, targetPSRBrand: string, meta_labels: DataContainer, tile_meta_labels: DataContainer, masFeatureTrackingLabels: DataContainer) {
        const trackingFeatures = [this.createTopBrandPromoTrackingFeature(featureOrder, 'loaded', masFeatureTrackingLabels, meta_labels)];
        trackingFeatures.push(this.createTopBrandPromoTileTrackingFeature('loaded', brandImageId, targetPSRBrand, tile_meta_labels));
        submitMerge({}, trackingFeatures);
    }

    sendToAllBrandsLinkInitialLoadedTrackingEvent(featureOrder: number, targetUrl: string, masFeatureTrackingLabels: DataContainer) {
        const trackingFeatures = [this.createToAllBrandsLinkTrackingFeature(featureOrder, 'loaded', masFeatureTrackingLabels)];
        trackingFeatures.push(this.createToAllBrandsLinkTileTrackingFeature('loaded', targetUrl));
        submitMerge({}, trackingFeatures);
    }

    sendVisibleTrackingEvent(featureId: string, featureTileId: string) {
        const topBrandPromoFeatureMiniAction = this.createTopBrandPromoFeatureMiniAction(featureId);
        const topBrandPromoTileFeatureMiniAction = this.createTopBrandPromoTileFeatureMiniAction(featureTileId);
        submitMiniAction([topBrandPromoFeatureMiniAction, topBrandPromoTileFeatureMiniAction]);
    }

    sendTopBrandPromoClickTrackingEvent(featureOrder: number, brandImageId: string, targetPSRBrand: string, meta_labels: DataContainer, tile_meta_labels: DataContainer, masFeatureTrackingLabels: DataContainer, masNextPiTrackingLabels: DataContainer) {
        const featureTrackingData: Action = {
            name: 'click',
            features: [
                this.createTopBrandPromoTrackingFeature(featureOrder, 'clicked', masFeatureTrackingLabels, meta_labels),
                this.createTopBrandPromoTileTrackingFeature('clicked', brandImageId, targetPSRBrand, tile_meta_labels)]
        };
        const wkTrackingData: DataContainer = this.createTopBrandPromoWkTrackingData(tile_meta_labels);
        submitMove(wkTrackingData, featureTrackingData);
        const existingNextPiTrackingLabels = {'promo_Click': ['TopBrandPromo']};
        const nextPiTrackingLabels = {
            ...existingNextPiTrackingLabels,
            ...masNextPiTrackingLabels
        };
        trackOnNextPageImpression(nextPiTrackingLabels);
    }

    sendToAllBrandsLinkClickTrackingEvent(featureOrder: number, masFeatureTrackingLabels: DataContainer, masNextPiTrackingLabels: DataContainer, targetUrl: string) {
        const featureTrackingData: Action = {
            name: 'click',
            features: [
                this.createToAllBrandsLinkTrackingFeature(featureOrder, 'clicked', masFeatureTrackingLabels),
                this.createToAllBrandsLinkTileTrackingFeature('clicked', targetUrl)]
        };
        const wkTrackingData: DataContainer = this.createToAllBrandsLinkWkTrackingData();
        submitMove(wkTrackingData, featureTrackingData);
        const existingNextPiTrackingLabels = {'promo_Click': ['ToAllBrandsLink']};
        const nextPiTrackingLabels = {
            ...existingNextPiTrackingLabels,
            ...masNextPiTrackingLabels
        };
        trackOnNextPageImpression(nextPiTrackingLabels);
    }


    private createTopBrandPromoWkTrackingData(tile_meta_labels: DataContainer): DataContainer {
        return {
            'wk.promo_AttributionFeature': ['TopBrandPromo_Storefront'],
            'wk.promo_AttributionSource': tile_meta_labels.tsl_Source ? tile_meta_labels.tsl_Source : ['TopBrandPromo']
        };
    }

    private createToAllBrandsLinkWkTrackingData(): DataContainer {
        return {
            'wk.promo_AttributionFeature': ['ToAllBrandsLink_Storefront'],
            'wk.promo_AttributionSource': ['manual']
        };
    }


    private createTopBrandPromoTrackingFeature(featureOrder: number, status: TrackingFeatureStatus, masFeatureTrackingLabels: DataContainer, meta_labels: DataContainer): Feature {
        return {
            id: 'ft3_tbp',
            position: featureOrder,
            name: 'TopBrandPromo',
            status: status,
            labels: {
                ...masFeatureTrackingLabels,
                promo_Feature: ['true'],
                promo_FeatureNumber: ['1'],
                promo_FilledSlots: ['1'],
                promo_TeslaModel: meta_labels.TeslaModel
            }
        };
    }

    private createTopBrandPromoTileTrackingFeature(status: TrackingFeatureStatus, brandImageId: string, targetPSRBrand: string, meta_labels: DataContainer): Feature {
        return {
            id: 'ft3_tbp_tile0',
            status: status,
            name: 'TopBrandPromo-Tile',
            parentId: 'ft3_tbp',
            labels: {
                ...meta_labels,
                promo_Source: meta_labels.tsl_Source,
                promo_BrandImageId: [brandImageId],
                promo_TargetPSRBrand: [targetPSRBrand]
            }
        };
    }

    private createTopBrandPromoFeatureMiniAction(featureId: string): MiniAction {
        return {
            featureId: featureId,
            action: 'scroll'
        };
    }

    private createTopBrandPromoTileFeatureMiniAction(featureId: string): MiniAction {
        return {
            featureId: featureId,
            action: 'scroll'
        };
    }

    private createToAllBrandsLinkTrackingFeature(featureOrder: number, status: TrackingFeatureStatus, masFeatureTrackingLabels: DataContainer): Feature {
        return {
            id: 'ft3_tabl',
            position: featureOrder,
            name: 'ToAllBrandsLink',
            status: status,
            labels: {
                ...masFeatureTrackingLabels,
                promo_Feature: ['true']
            }
        };
    }

    private createToAllBrandsLinkTileTrackingFeature(status: TrackingFeatureStatus, targetUrl: string): Feature {
        return {
            id: 'ft3_tabl_tile0',
            status: status,
            name: 'ToAllBrandsLink-Tile',
            parentId: 'ft3_tabl',
            labels: {
                promo_Content: [targetUrl],
                promo_Source: ['manual']
            }
        };
    }
}